import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// v14ae — Uniforme "Open project" actie voor de Projectenoverzichten.
// Gebruikt zowel in de lijstweergave als in de kaartweergave zodat er één
// bron van waarheid is voor label, route en styling.
//
// Design System v1 secondary/outlined:
//   • lichte achtergrond (wit)
//   • dunne border in neutrale grijstoon (#E5E2DC)
//   • tekst in donker neutraal (#2C2C2A)
//   • hover/focus: border + tekst wisselen naar terracotta accent (#D96C4A)
//     met een subtiele accent-background (rgba warm-tint via bg-[#FFF5EF])
//   • focus-visible ring in accentkleur voor keyboard-navigatie

export default function OpenProjectButton({
  projectId,
  className = "",
  size = "md",       // "md" (kaart, h-11) of "sm" (lijst, h-9)
  testId,
  children,
}) {
  const height = size === "sm" ? "h-9 px-3 text-sm" : "h-11 px-4 text-sm";
  return (
    <Link
      to={`/projecten/${projectId}`}
      data-testid={testId || `open-project-${projectId}`}
      className={
        `inline-flex items-center gap-1.5 rounded-xl bg-white border border-[#E5E2DC] ` +
        `text-[#2C2C2A] font-medium ${height} transition-colors ` +
        `hover:bg-[#FFF5EF] hover:border-[#D96C4A] hover:text-[#D96C4A] ` +
        `focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D96C4A]/40 ` +
        `focus-visible:border-[#D96C4A] focus-visible:text-[#D96C4A] ` +
        className
      }
    >
      {children || "Open project"} <ArrowRight className="w-4 h-4" />
    </Link>
  );
}
